import { useLayoutEffect, useRef } from 'react';
import { notifyBackIntentChange } from './backIntentBus.js';

const stack = [];

export function getAppBackStackSize() {
  return stack.length;
}

export function invokeTopAppBack() {
  if (stack.length === 0) return false;
  stack[stack.length - 1]();
  return true;
}

export function resetAppBackStackForTests() {
  stack.length = 0;
}

/**
 * Push a page-level back handler. Nested screens: last mount wins (LIFO).
 * Android/browser Back invokes this after overlay (Escape) handlers.
 */
export function registerAppBackHandler(onBack) {
  stack.push(onBack);
  notifyBackIntentChange();
  return () => {
    const i = stack.lastIndexOf(onBack);
    if (i !== -1) stack.splice(i, 1);
    notifyBackIntentChange();
  };
}

/**
 * Registers `onBack` while mounted and `enabled` — same action as the
 * visible Rentalyzer ← Retour button.
 */
export function useRegisterAppBack(onBack, enabled = true) {
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const entry = () => onBackRef.current?.();
    return registerAppBackHandler(entry);
  }, [enabled]);
}
